<template>


  <!---

v-show  显示隐藏  display

v-if  dom操作

-->


  <div id="start">

    <div v-show='showLoading'>

      放loading图片 gif showLoading...........
    </div>


    <div class="start_content" v-show="!showLoading">

      <header class="start_header">
        <img src="../assets/images/canju.png" /> 请输入手机号
      </header>

      <p class="notice"></p>

      <div class="content">
        <!--<ul class="user_list">
                        <li v-for="(item,key) in userList" :class="{'active':key==0}">
                            <span>{{item}}</span>
                        </li>
                    </ul>-->

        <div class="mark_input">
          <input type="text" v-model='p_mark' placeholder="请输入手机号" />
        </div>


        <ul class="mark_list">
          <!--<li>
                            <span>请输入手机号</span>
                        </li>
                        <li>
                            <span>
                               送货及时
                            </span>
                        </li>-->

        </ul>

      </div>

    </div>

    <div v-if="!showLoading" id="start" class="start" @click="addPeopleInfo()">
      <span>
        开始点单
      </span>
    </div>

  </div>
</template>


<script>
  //引入config

  import Config from '../model/config.js'

  import storage from '../model/storage.js';

  export default {

    data() {
      return {
        'p_num': '1人',
        'p_mark': '',
        'api': Config.api,
        'userList': [],
        'showLoading': true

      }
    },

    methods: {
      addChangeEnvet() {

        var that = this; /*保存this*/
        //alert(storage.get('roomid'));//szy add
        //人数的dom操作
        var userLis = document.querySelectorAll('.user_list li');

        for (var i = 0; i < userLis.length; i++) {
          userLis[i].onclick = function() {


            //去掉所有的li的class，让当前点击的li的class等于active

            for (var j = 0; j < userLis.length; j++) {
              userLis[j].className = '';
            }
            this.className = 'active'; //this 就是li这个dom节点

            //trim()表示去除空格

            that.p_num = this.querySelector('span').innerHTML.trim();

          }

        }




        //口味的dom操作
        var markLis = document.querySelectorAll('.mark_list li');

        for (var i = 0; i < markLis.length; i++) {
          markLis[i].onclick = function() {

            for (var j = 0; j < markLis.length; j++) {
              markLis[j].className = '';
            }
            this.className = 'active'; //this 就是li这个dom节点

            that.p_mark = that.p_mark + ' ' + this.querySelector('span').innerHTML.trim();
          }

        }


      },
      addPeopleInfo() {

        //桌子id  桌子号：是扫描二维码从url获取的

        var uid = String(storage.get('roomid'));//UID有时读到的为null,即没保存进去

        //cookie:
        //var uid = String(storage.getCookie('roomid'));

        //alert('uid='+uid);

        //如果UID为乱码，怎么办？UID显示三种：null,乱码，正确房号,房号的开头为A或1
        if ((uid.substring(0,1)=="A")  || (uid.substring(0,1)=="1") ) {

          storage.set(String(uid), String(this.p_mark)); //SZY ADD,房号和手机号，在本手机上取，既不被别人读取，也方便多次下单
          
          //storage.setCookie(String(uid), String(this.p_mark),7);

          this.$router.push({
            path: 'home'
          }) //点击人数保存成功后，路由到点菜页面

        } else {
           alert('房号不正确或号码为空，请再扫码（'+uid+'/'+this.p_mark+')');
           
		   //storage.clear();

        }
        /* var api = this.api + 'api/addPeopleInfo';
         this.$http.post(api, {
           uid: uid,
           p_num: this.p_num,
           p_mark: this.p_mark
         }).then((response) => {
           if (response.body.success) {

             this.$router.push({
               path: 'home'
             }) //点击人数保存成功后，路由到点菜页面
           }
         }, (err) => {
           console.log(err);
         })*/ //szy mod

      },
      getPeopleInfoList() {
        //此处为什么不是扫描桌子上的二维码呢?如果扫描，怎么切入进到这段代码来？手机上能及时存储房号
        //var roomid = window.location.hash.split('=')[1];//szy add,在浏览器改变房号，不能及时刷新localstorage
        //roomid=roomid.substring(0,4);//PC和手机浏览器扫码没问题，支付宝扫码也没问题，但微信扫码后，尾缀的房号后面增加了“&nsukey”,导致识别房号出错。
        //storage.set('roomid', roomid); //临时存储该房号，以备后面自己或别人访问时用,SZY ADD,解决扫码后不能及时更新房号

        var uid = String(storage.get('roomid'));

        var p_mark = String(storage.get(uid)); //szy add

        //cookie:
        //var uid = String(storage.getCookie('roomid'));
        //var p_mark = String(storage.getCookie(uid)); //szy add
        //alert('uid='+uid);

        /*
        运算符	描述	例子
        &&	and	(x < 10 && y > 1) 为 true
        ||	or	(x==5 || y==5) 为 false
        !	not	!(x==y) 为 true
        */
      
          if ((uid.substring(0,1)=="A")  || (uid.substring(0,1)=="1") ) {
            //如果UID为乱码，怎么办？UID显示三种：null,乱码，正确房号,房号的开头为A或1

          this.showLoading = false;

          if (p_mark !="null") {
            this.$router.push({
              path: 'home'
            }) //如果之前有人确定了人数，则转到点菜页面
          }
        } else {
           alert('房号不正确或号码为空，请再扫码（'+uid+'/'+this.p_mark+')');
           //storage.clear();

        }




        //alert('2:'+uid);//szy add,  下单完毕，立马将peopleInfoList表中的uid行删除，和清除storage，下次重新扫描
        /*var api=this.api+'api/peopleInfoList?uid='+uid;//url中加入api/可以跨域

        this.$http.get(api).then(response => {

            this.showLoading=false;

            //如果有用餐人数信息直接跳转到 点餐页面
            if(response.body.result.length>0){

                this.$router.push({ path: 'home' })//如果之前有人确定了人数，则转到点菜页面
            }

        }, response => {
            // error callback
        });*/


      }
    },
    created() {

      //判断 有没有用餐人数的信息
      this.getPeopleInfoList();
    },
    mounted() { //已经创建好了，准备进入



      //for(var i=0;i<10;i++){

      //    this.userList.push(i+1+'人');
      //}


      //数据没有渲染完成，就去获取dom节点

      //数据渲染完成再去获取

      this.$nextTick(function() {
        this.addChangeEnvet();
      })

    }
  }
</script>

<style lang="scss">
  .start_content {



    .start_header {

      height: 3.2rem;

      line-height: 3.2rem;
      background: #000;

      color: #fff;

      width: 10rem;

      margin: 5rem auto 0rem auto;

      border-radius: .5rem;

      img {

        height: 2.2rem;

        line-height: 2.2rem;
        position: relative;

        top: .5rem;
        margin-left: 1rem;
      }
    }


    .notice {

      color: red;
      //
      text-align: center;

      font-size: 4.5rem; //szy add


      margin: 1rem 0rem;


    }


    .mark_input {
      padding: 1rem;

      input {

        height: 8rem;
        line-height: 8rem;

        font-size: 4.5rem; //szy add

        width: 100%;
        border: 1px solid #eee;
      }

    }

    .user_list,
    .mark_list {

      display: flex;

      flex-wrap: wrap;
      padding: .5rem;

      li {

        width: 25%;
        padding: .5rem;
        box-sizing: border-box;
        /*盒子的宽度=盒子本身宽度    默认 盒子的宽度=盒子的宽度+padding+border*/

        span {

          display: block;

          width: 100%;
          height: 3.2rem;

          line-height: 3.2rem;
          text-align: center;
          background: #fff;
          border-radius: .5rem;
          border: 1px solid #ccc;
        }

      }

      li.active {

        span {


          background: red;
          border: 1px solid red;

          color: #fff;
        }
      }


    }
  }

  .start {

    position: fixed;

    bottom: 5rem;

    left: 50%;
    margin-left: -3rem;

    width: 5rem;

    height: 5rem;

    border-radius: 50%;

    background: red;
    color: #fff;

    span {

      display: block;

      width: 3rem;

      margin: 0 auto;

      position: relative;

      top: 1.5rem;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/Start.vue